/**
 * Frontend build version — bump on every deployable change (YYYY.MM.DD.build).
 */
// 261008 prefs: skip GET/PUT /preferences without a session, honest save-result log; banner + store info logs behind debug switch
// 261008 Sparkco restyle: theme layer (dark default), Sparkco controls, transcript avatar/A-/A+, width breakpoints, Sparkco speaker colours
export const BUILD_VERSION = '2026.10.08.3';
